import React from "react";
import classnames from "classnames";

const navigate = {
  PREVIOUS: "PREV",
  NEXT: "NEXT",
  TODAY: "TODAY",
  DATE: "DATE",
};

class SLACalendarToolbar extends React.Component {
  navigate = (action) => {
    this.props.onNavigate(action);
  };

  view = (view) => {
    this.props.onView(view);
  };

  viewNamesGroup(messages) {
    let viewNames = this.props.views;
    const view = this.props.view;

    if (viewNames.length > 1) {
      return viewNames.map((name) => (
        <button
          type="button"
          key={name}
          className={classnames({ "rbc-active": view === name })}
          onClick={this.view.bind(null, name)}
        >
          {messages[name]}
        </button>
      ));
    }
  }

  render() {
    let {
      localizer: { messages },
      label,
      min,
      max,
      date,
    } = this.props;
    const maxFirstDay = new Date(max.getFullYear(), max.getMonth(), 1);
    var today = new Date();
    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <button
            type="button"
            disabled={date.getTime() <= min.getTime()}
            onClick={this.navigate.bind(null, navigate.PREVIOUS)}
          >
            <span className="prev-icon">&#8249;</span>
          </button>
          <button
            type="button"
            disabled={
              today.getTime() < min.getTime() || today.getTime() > max.getTime()
            }
            onClick={this.navigate.bind(null, navigate.TODAY)}
          >
            <span className="next-icon">{messages.today}</span>
          </button>
          <button
            disabled={date.getTime() >= maxFirstDay.getTime()}
            type="button"
            onClick={this.navigate.bind(null, navigate.NEXT)}
          >
            <span className="next-icon">&#8250;</span>
          </button>
        </span>
        <span className="rbc-toolbar-label">{label}</span>
        <span className="rbc-btn-group">{this.viewNamesGroup(messages)}</span>
      </div>
    );
  }
}

export { SLACalendarToolbar };
